"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _FieldCheckSubplots = _interopRequireDefault(require("@/ui/components/FieldCheckSubplots"));
var _InputFilterModal = _interopRequireDefault(require("@/ui/components/InputFilterModal"));
var _Colapse = _interopRequireDefault(require("@/ui/components/Colapse"));
var _ContentSchedulingComponent = _interopRequireDefault(require("./ContentSchedulingComponent"));
var _ModalDelete = _interopRequireDefault(require("../components/ModalDelete"));
var _ModalFinishService = _interopRequireDefault(require("../components/ModalFinishService"));
var _ListItensLeft = _interopRequireDefault(require("./ListItensLeft"));
var _ListDetailCollapseRows = _interopRequireDefault(require("./ListDetailCollapseRows"));
var _vuex = require("vuex");
var _constants = require("@/config/constants");
var _utils = require("@/utils");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default2 = exports.default = {
  name: 'ModalScheduling',
  components: {
    Colapse: _Colapse.default,
    ListItensLeft: _ListItensLeft.default,
    ContentSchedulingComponent: _ContentSchedulingComponent.default,
    ListDetailCollapseRows: _ListDetailCollapseRows.default,
    InputFilterModal: _InputFilterModal.default,
    FieldCheckSubplots: _FieldCheckSubplots.default
  },
  props: {
    plots: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titlePage: {
      type: String,
      default: 'Escolha de talhão'
    },
    service: {
      type: String,
      default: 'Colheita'
    },
    subDescription: {
      type: String,
      default: 'Selecione as informações abaixo para determinar o local do serviço agendado'
    },
    enableDesc: {
      type: Boolean,
      default: true
    },
    closedModal: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      step: 1,
      searchSubtalhao: '',
      searchFamilie: '',
      loadingPlot: null,
      checkAllSubPlotsItem: false,
      plotSelected: 0,
      selectedPlots: [],
      subsLength: 0,
      errors: [],
      scheduling: {
        date: new Date(),
        endRecurrenceDate: new Date(),
        occurrence: '',
        occurrencies: [],
        cycle: null,
        os: null,
        logs: [],
        workers: [],
        batchsId: [],
        clientsId: [],
        typeService: null,
        selfAllocatable: null,
        recurrenceType: null,
        archived: false,
        status: 'SCHEDULED',
        finishingDescription: '',
        customFields: [{
          name: 'Observações',
          placeholder: 'Observações',
          input: 'STRING'
        }]
      },
      modalFinalize: null,
      modalDelete: null,
      loadScheduling: false
    };
  },
  destroyed: function destroyed() {
    this.resetServiceSelected();
    this.removeSelectedPlots();
    this.removeSchedulePlots();
    this.resetScheduling();
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.loadScheduling = true;
            _context.n = 1;
            return this.createSelectedPlots();
          case 1:
            _context.n = 2;
            return this.loadSubplots();
          case 2:
            if (this.serviceSelected) this.preparesChange();else this.loadScheduling = false;
          case 3:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    schedulePlots: 'schedulePlots',
    serviceSelected: 'serviceSelected',
    allOcurrences: 'allOcurrences',
    allUsers: 'allUsers',
    isLoading: 'isLoading'
  })), {}, {
    subplotsFiltered: function subplotsFiltered() {
      var self = this;
      var itemPlot = self.schedulePlots[self.plotSelected];
      if (self.plotSelected !== null && itemPlot && itemPlot.subplots) {
        var subPlots = itemPlot.subplots.filter(function (item) {
          return item.nickname.toLowerCase().indexOf(self.searchSubtalhao.toLowerCase()) > -1;
        });
        return subPlots;
      }
      return [];
    },
    serviceStatus: function serviceStatus() {
      var status = this.serviceSelected ? this.serviceSelected.status : null;
      var item = _constants.SCHEDULING_STATUS.find(function (p) {
        return p.value === status;
      });
      return item ? item.name : 'Agendado';
    },
    checkExclusion: function checkExclusion() {
      return this.serviceSelected && !(this.serviceSelected.status.toLowerCase() !== 'SCHEDULED'.toLowerCase());
    },
    serviceStatusItem: function serviceStatusItem() {
      return this.serviceSelected && this.serviceSelected.status.toLowerCase() !== 'FINISHED'.toLowerCase();
    }
  }),
  watch: {
    schedulePlots: function schedulePlots(val) {
      var _this = this;
      this.onLoadPlot();
      setTimeout(function () {
        _this.onLoadPlot(false);
      }, 2);
    },
    plotSelected: function plotSelected(val) {
      this.loadSubplots();
      if (this.checkAllSubPlotsItem) this.checkAllSubPlotsItem = false;
      this.analyzeChecking();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['addSeletectedsPlots', 'createSelectedPlots', 'createSelectedsPlotsItens', 'removeSelectedPlots', 'removeSchedulePlots', 'checkedPlot', 'checkedSubPlot', 'getSubPlots', 'getLines', 'getBunches', 'saveNewScheduling', 'resetServiceSelected', 'resetServices', 'deleteService', 'setLoading'])), {}, {
    onLoadPlot: function onLoadPlot(type) {
      if (!this.loadingPlot) {
        this.loadingPlot = this.$buefy.loading.open({
          container: this.$refs.elementModalBody
        });
      }
      if (type === false) {
        this.loadingPlot.close();
        this.loadingPlot = null;
      }
    },
    filterFamilies: function filterFamilies(array, filter) {
      if (!array || !array.length) return [];
      var data = array.filter(function (item) {
        return item.name.indexOf(filter.toLowerCase()) > -1;
      });
      return data.sort((0, _utils.sortBy)('checked'));
    },
    close: function close() {
      this.$emit('close');
    },
    selectPlot: function selectPlot(index) {
      this.plotSelected = index;
    },
    checkedPlots: function checkedPlots(e, item, index) {
      this.selectPlot(index);
      this.checkedPlot(item);
    },
    selectActionSub: function selectActionSub(e, item) {
      var payload = {
        idxPlot: this.plotSelected,
        idSubPlot: e.target.id
      };
      this.checkedSubPlot(payload);
      this.analyzeChecking();
    },
    verifyItemChecked: function verifyItemChecked() {
      for (var index = 0; index < this.schedulePlots.length; index++) {
        var element = this.schedulePlots[index];
        if (element.checked === true) {
          this.plotSelected = index;
          break;
        }
      }
    },
    returnStep: function returnStep() {
      this.plotSelected = 0;
      this.step = 1;
      this.verifyItemChecked();
    },
    verifyNext: function verifyNext() {
      if (this.serviceSelected) {
        if (this.serviceStatusItem) return true;
      } else {
        if (this.schedulePlots.find(function (item) {
          return item.checked === true;
        })) return true;
      }
      return false;
    },
    getItemsSelected: function getItemsSelected(array, arrayCompare, type) {
      if (!array) return [];
      var data = [];
      if (type === 'string') data = '';
      array.map(function (item) {
        var itemSel = arrayCompare.find(function (p) {
          return p.id === item;
        });
        if (itemSel) {
          if (type === 'string') data = itemSel.name;else data.push(itemSel);
        }
      });
      return data;
    },
    preparesChange: function () {
      var _preparesChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var self, itemChange, dueDate;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              self = this;
              _context2.n = 1;
              return self.addSeletectedsPlots();
            case 1:
              self.verifyItemChecked();
              itemChange = _.cloneDeep(self.serviceSelected);
              dueDate = itemChange.dueDate.slice(0, 10);
              dueDate = (0, _moment.default)(dueDate, 'YYYY-MM-DD').toDate();
              self.scheduling = {
                date: dueDate,
                occurrence: itemChange.occurrencies ? self.getItemsSelected(itemChange.occurrencies, self.allOcurrences, 'string') : '',
                occurrencies: self.getItemsSelected(itemChange.occurrencies, self.allOcurrences),
                logs: itemChange.logs,
                workers: itemChange.workers,
                selfAllocatable: itemChange.selfAllocatable,
                recurrenceType: itemChange.recurrenceType,
                status: itemChange.status,
                finishingDescription: itemChange.finishingDescription || '',
                customFields: itemChange.customFields,
                archived: itemChange.archived ? itemChange.archived : false,
                typeService: itemChange.type.id,
                type: itemChange.type,
                batchsId: itemChange.batchsId || [],
                clientsId: itemChange.clientsId || [],
                cycle: itemChange.cycle && itemChange.cycle.length ? itemChange.cycle[0].id : null,
                os: itemChange.os && itemChange.os.length ? itemChange.os[0].id : null
              };
              _context2.n = 2;
              return self.loadSubplots();
            case 2:
              _context2.n = 3;
              return self.createSelectedsPlotsItens();
            case 3:
              self.plotSelected = 0;
              self.loadScheduling = false;
              self.step = 2;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function preparesChange() {
        return _preparesChange.apply(this, arguments);
      }
      return preparesChange;
    }(),
    resetScheduling: function resetScheduling() {
      this.scheduling = {
        date: new Date(),
        occurrence: '',
        occurrencies: [],
        logs: [],
        workers: [],
        batchsId: [],
        clientsId: [],
        serviceIds: [],
        selfAllocatable: null,
        recurrenceType: null,
        archived: false,
        status: 'SCHEDULED',
        finishingDescription: '',
        customFields: []
      };
    },
    deleteServiceSchedule: function deleteServiceSchedule(type) {
      if (type) this.scheduling.deleteRecurrent = true;
      this.deleteSchedule(this.scheduling);
      this.modalDelete.close();
    },
    openModalFinalize: function openModalFinalize() {
      this.modalFinalize = this.$buefy.modal.open({
        parent: this,
        component: _ModalFinishService.default,
        hasModalCard: true,
        canCancel: ['escape'],
        props: {
          finalizeService: this.finalizeService
        }
      });
    },
    finalizeService: function finalizeService(text) {
      this.modalFinalize.close();
      this.scheduling.finishingDescription = text;
      this.scheduling.status = 'FINISHED';
      this.nextAction();
    },
    actionActivies: function actionActivies(item) {
      var self = this;
      switch (item) {
        case 1:
          if (self.scheduling.status !== 'FINISHED') self.openModalFinalize();else {
            self.$buefy.toast.open({
              message: 'Agendamento já finalizado!',
              type: 'is-warning'
            });
          }
          break;
        case 2:
          self.$buefy.dialog.confirm({
            title: 'Arquivar Agendamento',
            message: 'Tem certeza de que deseja <b>arquivar</b> esse agendamento?',
            cancelText: 'Cancelar',
            confirmText: 'Arquivar',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: function onConfirm() {
              return self.arquivedScheduling();
            }
          });
          break;
        default:
          if (!self.checkExclusion) {
            return self.$buefy.toast.open({
              duration: 5000,
              message: "Agendamento n\xE3o pode ser exclu\xEDdo, pois j\xE1 teve andamento!",
              position: 'is-top',
              type: 'is-danger'
            });
          }
          var detailModal = {
            parent: this,
            component: _ModalDelete.default,
            hasModalCard: true,
            canCancel: ['escape'],
            props: {
              confirmAction: this.deleteServiceSchedule,
              type: 'bunche',
              saveItem: this.createBunches
            }
          };
          var recurrence = self.serviceSelected.recurrenceType;
          if (recurrence) {
            detailModal = {
              parent: this,
              component: _ModalDelete.default,
              hasModalCard: true,
              canCancel: ['escape'],
              props: {
                listButtons: ['cancel', 'confirm', 'confirmAll'],
                confirmAction: this.deleteServiceSchedule
              }
            };
          }
          this.modalDelete = this.$buefy.modal.open(detailModal);
          break;
      }
    },
    verifyItems: function verifyItems() {
      var self = this;
      var item = self.scheduling;
      self.errors = [];
      if (!item.typeService) {
        self.errors.push('typeService');
        self.$buefy.toast.open({
          duration: 5000,
          message: "Por favor, informe o tipo de servi\xE7o",
          position: 'is-top',
          type: 'is-danger'
        });
      }
      return !self.errors.length;
    },
    deleteSchedule: function () {
      var _deleteSchedule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(scheduling) {
        var self, date, now, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              self = this;
              date = (0, _moment.default)(self.scheduling.date).format('YYYY/MM/DD');
              now = (0, _moment.default)().format('YYYY/MM/DD');
              if (!(now <= date)) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return self.deleteService(scheduling);
            case 1:
              res = _context3.v;
              if (res) {
                self.resetServiceSelected();
                self.removeSelectedPlots();
                self.removeSchedulePlots();
                self.resetScheduling();
                self.closedModal('excluded');
                self.setLoading(false);
              }
              _context3.n = 3;
              break;
            case 2:
              self.$buefy.toast.open({
                duration: 5000,
                message: "Agendamento n\xE3o pode ser exclu\xEDdo, pois \xE9 anterior a data atual!",
                position: 'is-top',
                type: 'is-danger'
              });
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function deleteSchedule(_x) {
        return _deleteSchedule.apply(this, arguments);
      }
      return deleteSchedule;
    }(),
    arquivedScheduling: function () {
      var _arquivedScheduling = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.scheduling.archived = true;
              this.nextAction();
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function arquivedScheduling() {
        return _arquivedScheduling.apply(this, arguments);
      }
      return arquivedScheduling;
    }(),
    nextAction: function () {
      var _nextAction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var self, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              self = this;
              if (!(self.step === 1)) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return self.createSelectedsPlotsItens();
            case 1:
              self.plotSelected = 0;
              self.step = 2;
              _context5.n = 6;
              break;
            case 2:
              _context5.p = 2;
              if (!self.verifyItems()) {
                _context5.n = 4;
                break;
              }
              self.setLoading(true);
              _context5.n = 3;
              return self.saveNewScheduling(self.scheduling);
            case 3:
              self.resetServiceSelected();
              self.removeSelectedPlots();
              self.removeSchedulePlots();
              self.resetScheduling();
              self.setLoading(false);
              self.closedModal();
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t = _context5.v;
              self.$buefy.toast.open({
                duration: 5000,
                message: "Ocorreu um erro ao tentar gravar o registro",
                position: 'is-top',
                type: 'is-danger'
              });
              self.setLoading(false);
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 5]]);
      }));
      function nextAction() {
        return _nextAction.apply(this, arguments);
      }
      return nextAction;
    }(),
    loadSubplots: function () {
      var _loadSubplots = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var payload, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              payload = {
                idxPlot: this.plotSelected,
                plot: this.schedulePlots[this.plotSelected]
              };
              _context6.n = 1;
              return this.getSubPlots(payload);
            case 1:
              data = _context6.v;
              if (data) this.subsLength = data.length;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function loadSubplots() {
        return _loadSubplots.apply(this, arguments);
      }
      return loadSubplots;
    }(),
    loadLines: function () {
      var _loadLines = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(subPlot) {
        var payload;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              payload = {
                idxPlot: this.plotSelected,
                subPlot: subPlot,
                step: this.step
              };
              _context7.n = 1;
              return this.getLines(payload);
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function loadLines(_x2) {
        return _loadLines.apply(this, arguments);
      }
      return loadLines;
    }(),
    checkAllSubPlots: function checkAllSubPlots(type) {
      var itemCheck = !this.checkAllSubPlotsItem;
      if (type && type === 'clear') {
        this.checkAllSubPlotsItem = false;
        itemCheck = false;
      }
      var payload = {
        idxPlot: this.plotSelected,
        all: itemCheck
      };
      this.checkedSubPlot(payload);
    },
    analyzeChecking: function analyzeChecking() {
      var plot = this.schedulePlots[this.plotSelected];
      if (plot.hasOwnProperty('subplots') && plot.subplots.length) {
        var total = plot.subplots.length;
        var checks = 0;
        plot.subplots.map(function (item) {
          if (item.checked) checks++;
        });
        if (total === checks) this.checkAllSubPlotsItem = true;else this.checkAllSubPlotsItem = false;
      }
    }
  })
};